export const SUPPORTED_BUSINESSES = ["kerakoll", "knauf"];